import { motion } from "framer-motion";

export function Example() {
  return (
    <motion.input
      style={{
        width: 250,
        background:
          "linear-gradient(to right, #fff -200%, #fff -100%, #fff 0%, #fff 100%))",
        border: "none",
        borderRadius: 10,
        fontSize: 30,
        padding: "5px 10px"
      }}
      whileFocus={{
        background: [
          "linear-gradient(to right, #f0f -200%, #0ff -100%, #f0f 0%,   #0ff 100%)",
          "linear-gradient(to right, #f0f -100%, #0ff 0%,    #f0f 100%, #0ff 200%)",
          "linear-gradient(to right, #f0f 0%,    #0ff 100%,  #f0f 200%, #0ff 300%)"
        ]
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }}
    />
  );
}
